import { __decorate } from "tslib";
import tableModel from '@blade-sxp/device-management/components/model.vue';
import { devicesTypes } from '@blade-sxp/device-management/api/device-management/index';
import { Component, Vue, Prop } from 'vue-property-decorator';
import deviceTable from '@blade-sxp/device-management/components/table.vue';
import uploadModel from '@blade-sxp/device-management/components/upload-model.vue';
import { delBatchDelete, devicesExport } from '@blade-sxp/device-management/api/device-group-management';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
const API = {
    delBatchDelete,
    devicesExport,
};
let default_1 = class default_1 extends Vue {
    permissionlevel = permissionlevel;
    title = `${this.$t('editDevice')}`;
    groupId;
    batchBtnIsShow;
    searchDialogVisible = false;
    dialogVisible = false;
    fullSkDialogVisible = false;
    type = '';
    uploadDialogVisible = false;
    failDialogVisible = false;
    analyticType = ['OBJECT_FACE', 'OBJECT_CROWD', 'OBJECT_FACE_PEDESTRIAN', 'OBJECT_MULTI_PACH', 'OBJECT_ALGO'];
    form = {
        keywords: '',
        // protocolType: '',
        deviceStatus: '',
        deviceType: '',
        analyticType: '',
    };
    onlineType = [
        { id: '0', name: `${this.$t('offline')}` },
        { id: '1', name: `${this.$t('online')}` },
        { id: '2', name: `${this.$t('unknown')}` },
    ];
    deviceType = [{ name: 'TCP' }, { name: 'UDP' }, { name: 'TCP_SERVER_MODE' }];
    protocolType = [{ name: 'TCP' }, { name: 'UDP' }, { name: 'TCP_SERVER_MODE' }];
    deleteList = [];
    isExport = true; // 是否能批量下载
    mounted() {
        this.getTypeList();
    }
    getScreenNum() {
        let num = 0;
        if (this.form.deviceStatus) {
            num++;
        }
        if (this.form.deviceType) {
            num++;
        }
        return num;
    }
    onSearch() {
        this.$refs.deviceTable.changeSearchVal();
        this.searchDialogVisible = false;
    }
    handleReset() {
        this.form = {
            keywords: '',
            // protocolType: '',
            deviceStatus: '',
            analyticType: '',
            deviceType: '',
        };
    }
    // 批量删除
    getDeviceList(selsectMap) {
        this.deleteList = [];
        selsectMap.forEach((val, key) => {
            this.deleteList.push(key);
            if (val.deviceType === 'VP_GB28181_STD') {
                this.isExport = false;
            }
        });
    }
    handleExport() {
        let obj = {
            deviceIds: this.deleteList,
            deviceType: this.form.deviceType,
        };
        API.devicesExport(obj)
            .then((res) => {
            if (res) {
                window.location.href = res;
            }
        })
            .catch((er) => {
            if (er.msg)
                this.$message.error(er.msg);
        });
    }
    // 批量导出
    handelBatchExport() {
        if (!this.form.deviceType || this.form.deviceType === 'VP_GB28181_STD') {
            let tips = this.form.deviceType === 'VP_GB28181_STD' ? this.$t('gbTipCon').toString() : this.$t('tipCon').toString();
            this.$elconfirm(tips, this.$t('tip').toString(), {
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: this.$t('confirm').toString(),
                confirmButtonClass: 'confirm-roi-tip',
                callback: (action) => { },
            });
            return;
        }
        this.fullSkDialogVisible = true;
    }
    handelBatchDel() {
        let deviceConfirmDelete = `${this.$t('deleteMsg')}`;
        let title = `${this.$t('deleteTitle')}`;
        this.$elconfirm(deviceConfirmDelete, title, {
            type: 'warning',
            callback: (action) => {
                if (action === 'confirm') {
                    API.delBatchDelete(this.deleteList)
                        .then((res) => {
                        if (res.length > 0) {
                            const listStr = res.join('，');
                            this.$alert(`${listStr} ${this.$t('batchDeletconfirm')}`, ` ${this.$t('batchDelete')}`, {
                                confirmButtonText: 'ok',
                            });
                        }
                        else {
                            this.$message({
                                message: `${this.$t('success')}`,
                                type: 'success',
                            });
                        }
                        this.$refs.deviceTable.getTaskList();
                        this.$emit('msgSuccess', this.groupId);
                    })
                        .catch(() => { });
                }
            },
        });
    }
    showAddModel() {
        this.dialogVisible = true;
        this.type = 'add';
    }
    msgSuccess(currentKey) {
        this.$emit('msgSuccess', currentKey);
    }
    changeMsgSuccess() {
        this.$refs.deviceTable.getTaskList();
        this.$emit('msgSuccess', this.groupId, false);
    }
    changeTopText() {
        this.$emit('changeTopText');
    }
    uploadDevice() {
        this.uploadDialogVisible = true;
    }
    getTypeList() {
        devicesTypes().then((res) => {
            this.deviceType = res;
        });
    }
    uploadSuccse() {
        this.$refs.deviceTable.getTaskList();
        this.$emit('msgSuccess', this.groupId);
    }
};
__decorate([
    Prop()
], default_1.prototype, "groupId", void 0);
__decorate([
    Prop()
], default_1.prototype, "batchBtnIsShow", void 0);
default_1 = __decorate([
    Component({
        name: 'rightTable',
        components: {
            deviceTable,
            tableModel,
            uploadModel,
            AuthNewitem,
            SecondaryVerification,
        },
        i18n: {
            messages: {
                en: {
                    reset: 'Reset',
                    ok: 'OK',
                    deleteTitle: 'Toast',
                    deleteMsg: 'Devices have been associated with the group. Are you sure you want to delete the group?',
                    batchDelete: 'Delete',
                    editDevice: 'Edit Device',
                    deviceDetails: 'Device Details',
                    batchImport: 'Batch Import',
                    addDevice: 'Add',
                    online: 'Online',
                    offline: 'Offline',
                    unknown: 'Unknown',
                    protocolType: 'Protocol Type',
                    analyticType: 'Analytic Type',
                    deviceType: 'Device Type',
                    deviceStatus: 'Online Status',
                    deviceName: 'Device Name/IP/Label/Key area',
                    device: 'Device',
                    batchDeletconfirm: 'The device has running tasks',
                    batchExport: 'Export',
                    confirm: 'Confirm',
                },
                zh: {
                    confirm: '确认',
                    batchExport: '批量导出',
                    reset: '重置',
                    deleteTitle: '提示',
                    deleteMsg: '设备已与该组关联。你确定要删除该组吗？',
                    batchDelete: '批量删除',
                    protocolType: '协议类型',
                    deviceType: '设备类型',
                    deviceStatus: '设备状态',
                    deviceName: '设备名字/ip/重点区域/标签',
                    editDevice: '设备编辑',
                    deviceDetails: '设备详情',
                    batchImport: '批量导入',
                    addDevice: '添加设备',
                    device: '设备',
                    online: '在线',
                    offline: '离线',
                    unknown: '未知',
                    analyticType: '分析型',
                    batchDeletconfirm: '设备有正在运行的任务，',
                    ok: '确定',
                },
            },
        },
    })
], default_1);
export default default_1;
